import React, { Component } from "react";
import {
  company,
  loading,
  NavbarAdmin,
  Pagination,
  Modal,
  Select,
  alert,
  GET,
  POST,
  PUT,
  DELETE,
  t,
  ActionIconButton,
  ACTION_ICONS,
} from "../../components/CustomComponent.js";
import { can } from "../../utils/permission.js";
import { formatNumber } from "../../utils/formatting";

// ประเภทพาหนะ (ISS-026) - ตรงกับคอมเมนต์ field vehicle_type ใน models/admin/company_vehicles.js
const VEHICLE_TYPES = ["car", "pickup", "van", "truck", "motorcycle"];

export default class CompanyVehicles extends Component {
  constructor(props) {
    super(props);
    this.state = {
      filter_search: "",
      filter_is_active: "",

      page: 1,
      page_size: 10,
      count: 0,
      data: [],

      modal_create: false,
      modal_update: false,

      // Form states
      uid: "",
      company_id: company?.id,
      vehicle_code: "",
      license_plate: "",
      province: "",
      vehicle_type: "car",
      brand: "",
      model: "",
      color: "",
      note: "",
      is_active: "Active",
    };
  }

  async componentDidMount() {
    loading(false);
    this.Get(1);
  }

  vehicleTypeOptions = () => VEHICLE_TYPES.map((value) => ({ value, label: t("cv_vehicle_type_" + value) }));

  Get = async (page) => {
    const { filter_search, filter_is_active, page_size } = this.state;
    loading(true);

    const result = await GET("admin/company-vehicles", {
      page_size,
      page,
      data_search: filter_search || "",
      is_active: filter_is_active || "",
      with_usage: true,
    });

    if (result?.status) {
      this.setState({
        data: result.data || [],
        count: result.pagination?.count || 0,
        page,
      });
    }

    loading(false);
  };

  openCreate = () =>
    this.setState({
      modal_create: true,
      modal_update: false,
      uid: "",
      vehicle_code: "",
      license_plate: "",
      province: "",
      vehicle_type: "car",
      brand: "",
      model: "",
      color: "",
      note: "",
      is_active: "Active",
    });

  openEdit = (item) =>
    this.setState({
      modal_create: false,
      modal_update: true,
      uid: item.uid,
      vehicle_code: item.vehicle_code || "",
      license_plate: item.license_plate || "",
      province: item.province || "",
      vehicle_type: item.vehicle_type || "car",
      brand: item.brand || "",
      model: item.model || "",
      color: item.color || "",
      note: item.note || "",
      is_active: item.is_active ? "Active" : "Inactive",
    });

  handleSave = async () => {
    const { uid, company_id, vehicle_code, license_plate, province, vehicle_type, brand, model, color, note, is_active } = this.state;

    if (!license_plate.trim()) {
      alert("", "warning", t("warning"), t("cv_validate_plate"));
      return;
    }

    if (await alert("", "info", t("confirm"), t("confirm_submission"), t("confirm"), t("cancel"))) {
      loading(true);

      const body = {
        company_id,
        vehicle_code: vehicle_code.trim(),
        license_plate: license_plate.trim(),
        province: province.trim(),
        vehicle_type: vehicle_type || "",
        brand: brand.trim(),
        model: model.trim(),
        color: color.trim(),
        note: note.trim(),
        is_active: is_active === "Active",
      };

      const result = !uid
        ? await POST("admin/company-vehicles", body)
        : await PUT("admin/company-vehicles/" + uid, body);

      if (result?.status === true) {
        alert("#", "success", t("success"), t("save_success"));
        this.setState({ modal_create: false, modal_update: false });
        this.Get(this.state.page);
      } else {
        alert("", "warning", t("warning"), result?.message || "An error occurred.");
      }
      loading(false);
    }
  };

  handleDelete = async (uid) => {
    if (await alert("", "warning", t("delete_item"), t("delete_desc"), t("confirm"), t("cancel"))) {
      loading(true);
      const result = await DELETE("admin/company-vehicles/" + uid, null);
      if (result?.status) {
        alert("#", "success", t("success"), t("delete_success"));
        this.Get(this.state.page);
      } else {
        alert("", "warning", t("warning"), result?.message || "An error occurred.");
      }
      loading(false);
    }
  };

  render() {
    const {
      data, count, page, page_size,
      filter_search, filter_is_active, modal_create, modal_update,
      vehicle_code, license_plate, province, vehicle_type, brand, model, color, note, is_active,
    } = this.state;

    return (
        <div className="w-100 min-vh-100" style={{ backgroundColor: "#F4F7FE" }}>
            <NavbarAdmin />
            <div className="body p-4 mt-3">
                {/* Header */}
                <div className="d-flex flex-wrap justify-content-between align-items-center mb-4 gap-3">
                    <div>
                        <h3 className="fw-bold mb-1 text-dark">{t("cv_title")}</h3>
                        <div className="text-secondary text-14">{t("cv_desc")}</div>
                    </div>
                </div>

                {/* Filter Toolbar */}
                <div className="rounded-4 bg-white p-3 mb-3 shadow-sm border-0">
                    <div className="d-flex flex-wrap align-items-center justify-content-between gap-3">
                        <div className="d-flex flex-wrap gap-2 flex-grow-1">
                            <div className="position-relative">
                                <span className="icon position-absolute top-50 start-0 translate-middle-y ms-3 text-secondary text-12">{""}</span>
                                <input
                                    type="text"
                                    className="form-control ps-5 wpx-350"
                                    style={{ height: "38px" }}
                                    placeholder={t("cv_search_placeholder")}
                                    value={filter_search}
                                    onChange={(e) => this.setState({ filter_search: e.target.value })}
                                    onKeyDown={(e) => e.key === "Enter" && this.Get(1)}
                                />
                            </div>
                            <Select
                                className="form-control wpx-180"
                                options={[
                                    { value: "true", label: t("active") },
                                    { value: "false", label: t("inactive") },
                                ]}
                                value={filter_is_active}
                                onChange={(e) => this.setState({ filter_is_active: e || "" })}
                                placeholder={t("all_status")}
                            />
                            <div className="d-flex gap-2">
                                <button className="btn btn-secondary px-3 py-2 fw-bold rounded-3 shadow-sm" onClick={() => this.Get(1)}>
                                    {t("filter")}
                                </button>
                                <button className="btn btn-white border px-3 py-2 fw-bold rounded-3 shadow-sm" onClick={() => this.setState({ filter_search: "", filter_is_active: "" }, () => this.Get(1))}>
                                    {t("clear_all")}
                                </button>
                            </div>
                        </div>
                        {can("company-vehicle.create") ? (
                        <button className="btn btn-primary px-3 py-2 fw-bold rounded-3 shadow-sm d-flex align-items-center" onClick={this.openCreate}>
                            <span className="me-2 text-16">+</span> {t("cv_add_btn")}
                        </button>
                        ) : null}
                    </div>
                </div>

                {/* Table */}
                <div className="bg-white rounded-4 shadow-sm overflow-hidden">
                    <div className="table-responsive">
                        <table className="table table-hover align-middle mb-0" style={{ minWidth: "900px" }}>
                            <thead>
                                <tr className="text-dark fw-bold text-12 border-bottom border-light">
                                    <th className="py-3 px-3 border-0">{t("cv_col_plate")}</th>
                                    <th className="py-3 px-3 border-0">{t("cv_col_brand_model")}</th>
                                    <th className="py-3 px-3 border-0 text-center wpx-150">{t("cv_col_vehicle_type")}</th>
                                    <th className="py-3 px-3 border-0 text-center wpx-120">{t("cv_col_usage")}</th>
                                    <th className="py-3 px-3 border-0 text-center wpx-120">{t("status")}</th>
                                    <th className="py-3 px-3 border-0 text-center wpx-120">{t("actions")}</th>
                                </tr>
                            </thead>
                            <tbody>
                                {data.length === 0 ? (
                                    <tr>
                                        <td colSpan={6} className="text-center text-secondary py-5">
                                            <div className="d-flex flex-column align-items-center gap-2">
                                                <span>{t("no_data")}</span>
                                            </div>
                                        </td>
                                    </tr>
                                ) : (
                                    data.map((item, idx) => (
                                        <tr key={item.uid || idx} className="border-bottom border-light bg-white">
                                            <td className="px-3">
                                                <div className="text-dark text-14 fw-semibold">{item.license_plate || item.vehicle_code || "-"}</div>
                                                {(item.province || item.vehicle_code) && (
                                                    <div className="text-secondary text-12">
                                                        {[item.province, item.license_plate && item.vehicle_code ? item.vehicle_code : null].filter(Boolean).join(" · ")}
                                                    </div>
                                                )}
                                            </td>
                                            <td className="px-3">
                                                <div className="text-dark text-14">{[item.brand, item.model].filter(Boolean).join(" ") || "-"}</div>
                                            </td>
                                            <td className="text-center">
                                                <div className="text-dark text-14">{item.vehicle_type ? t("cv_vehicle_type_" + item.vehicle_type) : "-"}</div>
                                            </td>
                                            <td className="text-center">
                                                <span className="text-primary text-12 fw-bold bg-primary-light px-2 py-1 rounded-pill">{formatNumber(item.usage_count ?? 0)}</span>
                                            </td>
                                            <td className="text-center">
                                                {item.is_active ? (
                                                    <span className="text-success text-12 fw-bold bg-success-light px-2 py-1 rounded-pill">{t("active")}</span>
                                                ) : (
                                                    <span className="text-secondary text-12 fw-bold bg-light px-2 py-1 rounded-pill border">{t("inactive")}</span>
                                                )}
                                            </td>
                                            <td className="text-center">
                                                <div className="d-flex align-items-center gap-2 justify-content-center">
                                                    <ActionIconButton label={can("company-vehicle.update") ? t("edit") : t("view")} icon={can("company-vehicle.update") ? ACTION_ICONS.edit : ACTION_ICONS.view} variant={can("company-vehicle.update") ? "warning" : "primary"} onClick={() => this.openEdit(item)} />
                                                    {can("company-vehicle.delete") ? (
                                                    <ActionIconButton label={t("delete")} icon={ACTION_ICONS.delete} variant="danger" onClick={() => this.handleDelete(item.uid)} />
                                                    ) : null}
                                                </div>
                                            </td>
                                        </tr>
                                    ))
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>

                {/* Footer Pagination */}
                <div className="d-flex justify-content-between align-items-center mt-4 flex-wrap text-secondary text-12 gap-2">
                    <div>
                        {t("showing")} {count === 0 ? 0 : formatNumber((page - 1) * page_size + 1)}-{formatNumber((page - 1) * page_size + data.length)} {t("of")} {formatNumber(count)} {t("cv_count")}
                    </div>
                    <Pagination className="mb-0" count={Math.ceil(count / page_size) || 1} page={page} showFirstButton={false} showLastButton={false} onChange={(_, p) => this.Get(p)} />
                </div>
            </div>

            {/* MODAL: CREATE / EDIT */}
            <Modal show={modal_create || modal_update} onHide={() => this.setState({ modal_create: false, modal_update: false })} centered contentClassName="border-0 rounded-4 shadow-lg">
                <Modal.Header className="border-bottom border-light px-4 py-3 bg-white" closeButton>
                    <h5 className="fw-bold mb-0 text-dark">{modal_update ? t("cv_modal_edit") : t("cv_modal_create")}</h5>
                </Modal.Header>
                <Modal.Body className="p-4 bg-white">
<fieldset disabled={this.state.modal_update && !can("company-vehicle.update")} className="border-0 p-0 m-0" style={{ minWidth: 0 }}>
                    <div className="row g-3">
                        {/* License plate / Province */}
                        <div className="col-md-6">
                            <label className="form-label text-14 text-dark mb-2">
                                {t("cv_field_plate")} <span className="text-danger">*</span>
                            </label>
                            <input type="text" className="form-control py-2" value={license_plate} onChange={(e) => this.setState({ license_plate: e.target.value })} />
                        </div>
                        <div className="col-md-6">
                            <label className="form-label text-14 text-dark mb-2">{t("cv_field_province")}</label>
                            <input type="text" className="form-control py-2" value={province} onChange={(e) => this.setState({ province: e.target.value })} />
                        </div>

                        {/* Vehicle code / type */}
                        <div className="col-md-6">
                            <label className="form-label text-14 text-dark mb-2">{t("cv_field_code")}</label>
                            <input type="text" className="form-control py-2" value={vehicle_code} onChange={(e) => this.setState({ vehicle_code: e.target.value })} />
                        </div>
                        <div className="col-md-6">
                            <label className="form-label text-14 text-dark mb-2">{t("cv_field_vehicle_type")}</label>
                            <Select
                                className="form-control w-100"
                                options={this.vehicleTypeOptions()}
                                value={vehicle_type}
                                onChange={(e) => this.setState({ vehicle_type: e || "" })}
                                placeholder={t("cv_field_vehicle_type")}
                            />
                        </div>

                        {/* Brand / Model / Color */}
                        <div className="col-md-4">
                            <label className="form-label text-14 text-dark mb-2">{t("cv_field_brand")}</label>
                            <input type="text" className="form-control py-2" value={brand} onChange={(e) => this.setState({ brand: e.target.value })} />
                        </div>
                        <div className="col-md-4">
                            <label className="form-label text-14 text-dark mb-2">{t("cv_field_model")}</label>
                            <input type="text" className="form-control py-2" value={model} onChange={(e) => this.setState({ model: e.target.value })} />
                        </div>
                        <div className="col-md-4">
                            <label className="form-label text-14 text-dark mb-2">{t("cv_field_color")}</label>
                            <input type="text" className="form-control py-2" value={color} onChange={(e) => this.setState({ color: e.target.value })} />
                        </div>

                        {/* Note */}
                        <div className="col-12">
                            <label className="form-label text-14 text-dark mb-2">{t("cv_field_note")}</label>
                            <textarea className="form-control py-2" rows={3} value={note} onChange={(e) => this.setState({ note: e.target.value })} />
                        </div>

                        {/* Status */}
                        <div className="col-12 mt-2 border-top pt-3">
                            <h6 className="fw-bold mb-3 d-flex align-items-center">
                                <span className="icon text-primary me-2">{""}</span> {t("status")}
                            </h6>
                            <div className="d-flex gap-4">
                                <div className="form-check d-flex align-items-center gap-2">
                                    <input
                                        className="form-check-input mt-0 pointer"
                                        type="radio"
                                        name="cvStatus"
                                        id="cvActive"
                                        checked={is_active === "Active"}
                                        onChange={() => this.setState({ is_active: "Active" })}
                                    />
                                    <label className="form-check-label text-dark text-14 pointer" htmlFor="cvActive">
                                        {t("active")}
                                    </label>
                                </div>
                                <div className="form-check d-flex align-items-center gap-2">
                                    <input
                                        className="form-check-input mt-0 pointer"
                                        type="radio"
                                        name="cvStatus"
                                        id="cvInactive"
                                        checked={is_active === "Inactive"}
                                        onChange={() => this.setState({ is_active: "Inactive" })}
                                    />
                                    <label className="form-check-label text-dark text-14 pointer" htmlFor="cvInactive">
                                        {t("inactive")}
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                </fieldset>
</Modal.Body>
                <Modal.Footer className="border-top border-light px-4 py-3 bg-white d-flex justify-content-end gap-2">
                    <button className="btn btn-white border px-4 py-2 text-dark rounded-3 fw-bold" onClick={() => this.setState({ modal_create: false, modal_update: false })}>
                        {t("cancel")}
                    </button>
                    {(!this.state.modal_update || can("company-vehicle.update")) ? <button
                        className="btn btn-primary px-4 py-2 d-flex align-items-center rounded-3 fw-bold text-white shadow-sm"
                        onClick={this.handleSave}
                    >
                        <span className="icon me-2">{""}</span> {t("save")}
                    </button> : null}
                </Modal.Footer>
            </Modal>
        </div>
    );
  }
}
